import { Action } from '@ngrx/store';
import { CarouselState } from './carousel.state';
import { ErrorResponse } from '~shared/models';

export enum CarouselActionTypes {
    LOAD_CAROUSEL_CONFIG = '[Buyer] Carousel Config Load',
    LOAD_PDP_CAROUSEL_CONFIG = '[Buyer] PDP Carousel Config Load',
    LOAD_CAROUSEL_CONFIG_SUCCESS = '[Buyer] Carousel Config Load Success',
    LOAD_CAROUSEL_CONFIG_FAILURE = '[Buyer] Carousel Config Load Failure',
}

export class LoadCarouselConfig implements Action {
    readonly type = CarouselActionTypes.LOAD_CAROUSEL_CONFIG;

    constructor(public payload: {}) {}
}

export class LoadCarouselConfigSuccess implements Action {
    readonly type = CarouselActionTypes.LOAD_CAROUSEL_CONFIG_SUCCESS;

    constructor(public payload: {response: CarouselState}) {}
}

export class LoadCarouselConfigFailure implements Action {
    readonly type = CarouselActionTypes.LOAD_CAROUSEL_CONFIG_FAILURE;

    constructor(public payload: {error: ErrorResponse}) {}
}

export type CarouselActionsUnion = LoadCarouselConfig
| LoadCarouselConfigSuccess
| LoadCarouselConfigFailure;
